import React                from 'react';
import PropTypes            from 'prop-types';

/* *********************************************************************************** */
/* **********                                                               ********** */
/* **********                            OngletMenu                         ********** */
/* **********                                                               ********** */
/* *********************************************************************************** */

export class OngletMenu extends React.Component {

  /* ------------ */
  /* Constructeur */
  /* ------------ */

    constructor(props) {
        super(props);
        this.state = {
            survol : false
        }

        this.trtSurvol    = this.trtSurvol.bind    (this);
        this.trtFinSurvol = this.trtFinSurvol.bind (this);
    }

    /* -------------------------------------- */
    /* Fonctions de survol ou non de l'onglet */
    /* -------------------------------------- */

    trtSurvol (){
        this.setState({survol: true})    
    }

    trtFinSurvol (){
        this.setState({survol: false})    
    }

    actionPage (){
        if (this.props.action) this.props.action (this.props.onglet.liAction);
    }

    /* ---------------------- */
    /* Affichage du composant */
    /* ---------------------- */

    render () {
        
        /* ------------------------------ */
        /* Définition des CSS d'affichage */
        /* ------------------------------ */

        const styleOngletMenu = {
            fontFamily      : "arial, verdana, times, sans-serif", 
            color           : "#000000", 
            fontSize        : "16px",
            fontWeight      : "bold",
            backgroundColor : "#A85833",
            backgroundImage : `url(${process.env.PUBLIC_URL + "/images/BeigeFonce.jpg"})`, 
            textAlign       : "center", 
            verticalAlign   : "middle",
            border          : "1px solid grey",
            cursor          : "default"
        }

        if (!this.props.vertical)          { styleOngletMenu.display         = "inline-block";}
        if (this.props.onglet.selection)   { styleOngletMenu.backgroundColor = "#BDDE18"; styleOngletMenu.color = "#FFFFFF"; styleOngletMenu.backgroundImage = `url(${process.env.PUBLIC_URL + "/images/Bois.jpg"})`; }
        if (this.props.onglet.largeur > 0) { styleOngletMenu.width           = this.props.onglet.largeur + "px"; }
        if (this.props.onglet.hauteur > 0) { styleOngletMenu.height          = this.props.onglet.hauteur + "px";  styleOngletMenu.lineHeight = this.props.onglet.hauteur + "px"; }
        if (this.state.survol)             { styleOngletMenu.backgroundColor = "#336699"; styleOngletMenu.color = "#FFFF00"; styleOngletMenu.cursor = 'pointer'; styleOngletMenu.backgroundImage = null;}
        
        if (!this.props.onglet.premier){ 
            if (this.props.vertical)
                styleOngletMenu.borderTop = "none"; 
            else
                styleOngletMenu.borderLeft = "none"; 
        }

        /* ------------------- */
        /* Renvoi du composant */
        /* ------------------- */

        return (

            <div style={styleOngletMenu} onMouseOver={this.trtSurvol} onMouseOut={this.trtFinSurvol} onClick={()=>this.actionPage()} tabIndex="0">
              { this.props.onglet.liOnglet }
            </div>

        )

    }
  
}

/* ------------------------------------ */
/* Définition de la structure des props */
/* ------------------------------------ */

OngletMenu.defaultProps = {
    onglet   : null,
    vertical : null,
    action   : null
}

OngletMenu.propTypes = {
    onglet   : PropTypes.object,
    vertical : PropTypes.bool,
    action   : PropTypes.func
}


// WEBPACK FOOTER //
// ./src/components/commun/OngletMenu.js